module.exports = __webpack_public_path__ + "img/meat.c4552c8f.svg";